import React, { useState } from 'react';
import UniversalTopBar from './UniversalTopBar';
import UniversalSidebar from './UniversalSidebar';
import CollapsedSidebar from './CollapsedSidebar';
import { useQuickActions } from '../contexts/QuickActionsContext';

const ResponsiveNavigation: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { openCreatePatientModal, openCreateUserModal } = useQuickActions();

  const handleMenuClick = () => {
    setSidebarOpen(true);
  };

  const handleSidebarClose = (open: boolean) => {
    setSidebarOpen(open);
  };

  const quickActions = {
    onCreatePatient: openCreatePatientModal,
    onCreateUser: openCreateUserModal,
  };

  return (
    <>
      {/* Universal Top Bar */}
      <UniversalTopBar onMenuClick={handleMenuClick} />
      
      {/* Universal Overlay Sidebar */}
      <UniversalSidebar 
        open={sidebarOpen} 
        onOpenChange={handleSidebarClose} 
        quickActions={quickActions}
      />
      
      {/* Collapsed Sidebar for desktop */}
      <CollapsedSidebar onMenuClick={handleMenuClick} />
      
      {/* Add top padding for fixed header */}
      <div className="h-14 md:h-16" />
    </>
  );
};

export default ResponsiveNavigation;